<template>
  <field v-bind="$props">
    <div slot>
      <div class="dropdown">
        <div
          v-if="!onlyCircle"
          class="input-wrapper"
        >
          <div
            class="color-input"
            :class="{ active: show }"
            @click="show = !show"
          >
            <div
              class="color-circle"
              :style="{ backgroundColor: colorHex }"
            />
            {{ colorName }}
          </div>
          <img
            v-if="show"
            src="~@/assets/ico/arrow-up-blue.svg"
            @click="hide"
          >
          <img
            v-else
            src="~@/assets/ico/arrow-down-blue.svg"
            @click="show = true"
          >
        </div>
        <div
          v-else
          class="color-circle"
          :style="{ backgroundColor: colorHex, borderColor: convert2rgba(colorHex, 40) }"
          :class="{'only-circle':onlyCircle, active:show}"
          @click="show = !show"
        />
        <transition name="fade">
          <div
            v-if="show"
            v-click-outside="hide"
            :class="onlyCircle?'only-circle-grid':'color-grid'"
          >
            <div
              v-for="(name, hex, index) in colors"
              :key="index"
              class="color-circle"
              :style="{ backgroundColor: hex, 'border-color': convert2rgba(hex, 40) }"
              @click="selected(hex)"
            />
          </div>
        </transition>
      </div>
    </div>
  </field>
</template>

<script>
import Field from './Field'
import vClickOutside from 'v-click-outside'
import Color from '@/components/Color'

export default {
  components: {
    Field,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  mixins: [Color],
  props: {
    value: String,
    title: String,
    description: String,
    dbname: String,
    onlyCircle: Boolean,
  },
  data() {
    return {
      show: false,
    }
  },
  created() {
    this.$emit('input', this.colorHex)
  },
  methods: {
    hide() {
      this.show = false
    },
    selected(hex) {
      this.colorHex = hex
      this.$emit('input', hex)
      this.hide()
    },
    convert2rgba(color, alpha) {
      color = color.replace('#', '')
      let r = parseInt(color.substring(0, 2), 16)
      let g = parseInt(color.substring(2, 4), 16)
      let b = parseInt(color.substring(4, 6), 16)
      let result = 'rgba(' + r + ',' + g + ',' + b + ',' + alpha / 100 + ')'
      return result
    },
  },
}
</script>

<style lang="scss" scoped>
.dropdown {
  width: 100%;
  position: relative;

  .color-circle {
    width: 14px;
    height: 14px;
    border-radius: 7px;
    margin-right: 8px;
    border:0;
    &.only-circle {
      cursor: pointer;
      border-width: 3px;
      box-sizing: content-box;
      background-clip: padding-box;
      border-radius: 100%;
      margin: 4px 12px 4px 4px;
      &:hover, &.active {
        border-width: 3px;
        border-style: solid;
        margin: 1px 9px 1px 1px;
      }
    }
  }
  .input-wrapper {
    display: flex;
    justify-content: space-between;

    .color-input {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: $regular;
      width: 100%;
      color: $black;
      padding: 10px;
      //margin-bottom: 1px;
      cursor: pointer;
      border: 1px solid $flax-bloom;
      transition: border-color 0.2s;
      .color-circle {
        width: 14px;
        height: 14px;
        border-radius: 7px;
        margin-right: 8px;
      }
      @include animate-border-default(1px, 0);
      &.active {
        border-color: $blue;
        @include animate-border-focused();
      }
    }
    img {
      position: absolute;
      cursor: pointer;
      width: 12px;
      height: 12px;
      align-self: center;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .color-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    z-index: 1;
    background-color: white;
    left: 0;
    right: 0;
    position: absolute;
    list-style-type: none;
    border: 1px solid $flax-bloom;
    border-top: 0;
    padding: 4px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);

    .color-circle {
      width: 22px;
      height: 22px;
      border-radius: 14px;
      margin: 4px;
      border-width: 0px;
      border-style: solid;
      cursor: pointer;
      box-sizing: content-box;
      background-clip: padding-box;
      &:hover {
        border-width: 3px;
        margin: 1px;
      }
    }
  }
  .only-circle-grid{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    z-index: 1;
    background-color: white;
    width: 310px;
    margin-top: 10px;
    left: 0;
    right: 0;
    position: absolute;
    list-style-type: none;
    border: 1px solid $flax-bloom;
    padding: 4px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);

    .color-circle {
      width: 22px;
      height: 22px;
      border-radius: 14px;
      margin: 4px;
      border-width: 0px;
      border-style: solid;
      cursor: pointer;
      box-sizing: content-box;
      background-clip: padding-box;
      &:hover {
        border-width: 3px;
        margin: 1px;
      }
    }
  }
}
</style>
